// Setup › Add-ons (`/c/{slug}/setup/addons`): owners, admins and agency operators (the
// Setup mode's roles). Locked rail items link here (`#kpi`, design spec §3, founder decision 1).
import { createRoute } from "@tanstack/react-router";
import { AddonsPage } from "../features/addons/addons-page";
import { useCompany } from "../features/use-feature";
import { setupRoute } from "./c.$slug.setup";

export const setupAddonsRoute = createRoute({
  getParentRoute: () => setupRoute,
  path: "addons",
  component: function SetupAddons() {
    const { api } = setupAddonsRoute.useRouteContext();
    return <AddonsPage api={api} company={useCompany()} />;
  },
});
